import { Toast, toast } from '@heroui/react';
import { createProviders } from '@hs/shared';
import { store } from '@/stores/store';
import { trpc, trpcClient, trpcProxyClient } from '@/lib/trpc';
import type { ErrorInfo } from '@hs/shared';
import { ThemeProvider } from '@/components/ThemeProvider';

/**
 * 应用根 Provider
 * 
 * ✅ 使用 shared 包的工厂函数创建 Providers
 * 
 * 组合了以下 Provider：
 * - tRPC Provider: API 请求
 * - React Query Provider: 数据缓存
 * - Redux Provider: 全局状态
 * - AuthProvider: 认证服务（用户信息获取 + 跨标签页同步）
 * - TokenRefreshHandler: Token 自动刷新
 * - ThemeProvider: 主题管理（基于 next-themes）
 * - HeroUI Toast.Provider + toast：全局错误提示
 * 
 * 注意：shadcn/ui 组件不需要 Provider，组件可直接使用
 */
// 创建 Providers 组件
const BaseProviders = createProviders({
  store,
  trpc: trpc as any,
  trpcClient,
  trpcProxyClient,
  loginPath: '/login',
  isHomeApp: false, // ✅ app 应用：需要登录才能访问
  onError: (errorInfo: ErrorInfo) => {
    // HeroUI toast
    toast.danger('操作失败', {
      description: errorInfo.message,
      timeout: 3000,
    });
  },
});

// 导出 Providers 组件（含 ThemeProvider 与 Toast.Provider）
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ThemeProvider>
        <Toast.Provider placement="top" />
        <BaseProviders>{children}</BaseProviders>
      </ThemeProvider>
    </>
  );
}

